import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax, Power0 } from 'gsap'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import SlideHOC from '../SlideHOC'
import Video from './Video'
import ANIMATION_TYPES from '../../../../constants/animationTypes'

import './VideoScene.scss'

class VideoScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .to(this.contentRef, 0, { xPercent: 0 })
      .fromTo(this.rootRef, this.props.duration / 2, { autoAlpha: 0, scale: 0.5 },
        { scale: 1, autoAlpha: 1, ease: Power0.easeNone, delay: this.props.duration / 2 })

    this.inReversedAnimation = new TimelineMax({ paused: true })
    .to(this.contentRef, 0, { autoAlpha: 0 })
    .to(this.rootRef, 0, { autoAlpha: 1, zIndex: 10, xPercent: 0, immediateRender: false })
    .fromTo(this.wrapperRef, this.props.fastDuration, { xPercent: -120, rotationY: 0 }, { xPercent: 0, rotationY: 0 })
    .fromTo(this.contentRef, this.props.fastDuration * 0.5, { xPercent: -150, autoAlpha: 0 }, { autoAlpha: 1, xPercent: 3, delay: this.props.fastDuration * 0.5, immediateRender: false }, 0)
    .fromTo(this.contentRef, this.props.fastDuration * 0.5, { xPercent: 3 }, { xPercent: -1.5, delay: this.props.fastDuration * 0.5 * 2 }, 0)
    .to(this.contentRef, this.props.fastDuration * 0.5, { xPercent: 0, delay: this.props.fastDuration * 0.5 * 3 }, 0)

    this.outAnimation = new TimelineMax({ paused: true })
    .to(this.rootRef, 0, { zIndex: 1 }, 0)
    .fromTo(this.rootRef, this.props.fastDuration, { xPercent: 0, autoAlpha: 1, immediateRender: false }, { autoAlpha: 0 })
    .fromTo(this.wrapperRef, this.props.fastDuration, { rotationY: 0, xPercent: 0 }, { xPercent: 0, rotationY: 100, transformOrigin: 'left' }, 0)

    this.outReversedAnimation = this.outAnimation
  }

  render () {
    const { video, title, description, onNext, button } = this.props
    const { currentAnimationType } = this
    return (
      <div className='bo_video' ref={ref => (this.rootRef = ref)}>
        <div className='bo_video__wrapper' ref={ref => (this.wrapperRef = ref)}>
          <Video
            video={video.url}
            videoBg={video.thumbUrl}
            focused={currentAnimationType === ANIMATION_TYPES.IN || currentAnimationType === ANIMATION_TYPES.IN_REVERSED}
          />

          <CSSTransitionGroup
            transitionName='bo_video'
            transitionEnterTimeout={1000}
            transitionLeaveTimeout={1000}
          >
            <div id='bo_video__content' className='bo_video__content' ref={ref => (this.contentRef = ref)}>
              <div id='bo_video__title' className='bo_video__title'>
                <span className='bo_video__title--text'>
                  {title}
                </span>
              </div>
              <div className='bo_video__divider' />
              <div id='bo_video__description' className='bo_video__description'>
                <span className='bo_video__description--text'>
                  {description}
                </span>
              </div>

              <div className='bo_video__button-wrapper'>
                <button id='bo_video__button' className='bo_video__button' onClick={onNext}>{button}</button>
              </div>
            </div>
          </CSSTransitionGroup>

        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 2,
    fastDuration: 0.5
  }

  static propTypes = {
    video: PropTypes.object,
    title: PropTypes.string,
    button: PropTypes.string,
    description: PropTypes.string,
    onNext: PropTypes.func,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number,
   fastDuration: PropTypes.number
  }
}

export default SlideHOC(VideoScene)



// WEBPACK FOOTER //
// ./src/templates/bouncy/components/video/VideoScene.js